<p-toast></p-toast>

<div class="table">
  <div>
    <ng-container *ngIf="addEventSlider">
      <p-drawer 
        class="addEvent-slider" 
        [(visible)]="addEventSlider" 
        styleClass="p-drawer-lg" 
        [showCloseIcon]="true" 
        position="right" 
        (onHide)="closeEventSideBar()" 
        [modal]="true"
        [dismissible]="false"
        [style]="{ width: '60vw' }">
        <div *ngIf="addEventSlider">
          <app-events-add 
            *ngIf="cloneEventData?.id == undefined" 
            (closeEventSlider)="onCloseEventSlider($event)">
          </app-events-add>
          <app-events-add 
            *ngIf="cloneEventData?.id?.length" 
            [isEventCloneData]="true" 
            [eventCloneData]="cloneEventData" 
            [eventJobData]="eventJobData" 
            (closeEventSlider)="onCloseEventSlider($event)">
          </app-events-add>
        </div>
      </p-drawer>
    </ng-container>
  </div>
<!-- Column Settings Sidebar -->
<p-drawer   
  styleClass="settingsSidebar"   
  [transitionOptions]="'300ms'"   
  [(visible)]="showSettingsSidebar"   
  (onShow)="updatedSelectedColFields()"
  [modal]="false"  
  position="right"  
  [showCloseIcon]="false"  
  [baseZIndex]="1000">
  
  <div class="settings-sidebar-header">
    <h3 class="settings-sidebar-title"> Column Settings</h3>
  </div>  
  <div class="settings-sidebar-center">
    <div class="settings-content-container">
      <!-- Search -->
      <div class="settings-search-container">
        <i class="pi pi-search"></i>
        <input 
          type="text"
          class="settings-search-input"
          placeholder="Search" 
          [(ngModel)]="columnSearchTerm"
          (ngModelChange)="searchColumns($event)" />
      </div>
      
      <div class="saved-columns-section" *ngIf="savedColumnSettings.length > 0">
        <div class="saved-columns-header">Saved Columns</div>
        <div class="saved-column-item" *ngFor="let column of savedColumnSettings" (click)="applySavedSettings(column.saved_columns)">
          <span class="saved-column-name">{{column.name}}</span>
          <i class="pi pi-trash saved-column-delete" (click)="$event.stopPropagation(); deleteSavedColumns(column.id)"></i>
        </div>
      </div>
      
      <!-- Column Selection -->
      <div class="settings-columns-section">
        <div class="settings-column-item" *ngFor="let col of _eventsCol">
          <div class="column-item-left">
            <!-- <p-checkbox 
              name="category"
              [value]="col"
              [(ngModel)]="checkedColumns"
              [inputId]="col.field">
            </p-checkbox> -->
            <p-checkbox 
              name="category"
              [value]="col.field"
              [ngModel]="checkedColumnsFields"
              (ngModelChange)="updateCheckedColumns($event)"
              [inputId]="col.field">
            </p-checkbox>
            <label [for]="col.field" class="settings-column-label">{{col.header}}</label>
          </div>
          <i class="fas fa-grip-vertical drag-handle"></i>
        </div>
      </div>
      
      <!-- Save Settings Section -->
      <div class="save-settings-section" *ngIf="!displaySaveColumnSettings">
        <div class="save-settings-toggle" (click)="displaySaveColumnSettings = true">
          Save Selected Columns      
        </div>
      </div>
      
      <!-- Save Form -->
      <div class="save-settings-section" *ngIf="displaySaveColumnSettings">
        <form class="save-settings-form" [formGroup]="columnSettings" (ngSubmit)="saveColumnSettings()">
          <input 
            type="text"
            class="save-settings-input"
            placeholder="Enter Column Set Name" 
            formControlName="name">
          <button type="submit" pButton class="save-settings-btn" label="Save"></button>
          <button type="button" pButton class="p-button-text" (click)="clearColumnPreferenceName()">
            <i class="pi pi-times"></i>
          </button>
        </form>
      </div>
    </div>
  </div>
  
  <!-- Footer with #FCFBFF background -->
  <div class="settings-actions">
    <button 
      pButton 
      [outlined]="true"
      size="small"
      class="settings-cancel-btn"
      label="Cancel"
      (click)="showSettingsSidebar = false;resetCheckedColumnsToDefault();clearColumnPreferenceName()">
    </button>
    <button 
      pButton 
      class="settings-apply-btn"
      label="Apply"
      (click)="applySelectedColumns()">
    </button>
  </div>
</p-drawer>

<!-- Download Sidebar -->
<p-drawer   
  styleClass="downloadSidebar eventListDownload"   
  [transitionOptions]="'300ms'"   
  [(visible)]="showDownloadSidebar"   
  [modal]="false"  
  position="right"  
  [showCloseIcon]="false"  
  [baseZIndex]="1000">
  
  <!-- Header -->
  <div class="download-sidebar-header">
    <div class="header-top-row">
      <h3 class="download-sidebar-title">Download Event Data</h3>
      <div class="format-toggle">
        <div class="format-option">
          <div class="format-radio" [ngClass]="{'active': downloadAs === 'csv'}" (click)="downloadAs = 'csv'">
            <i class="pi pi-check" *ngIf="downloadAs === 'csv'"></i>
          </div>
          <span class="format-label" (click)="downloadAs = 'csv'">CSV</span>
        </div>
        <div class="format-option">
          <div class="format-radio" [ngClass]="{'active': downloadAs === 'excel'}" (click)="downloadAs = 'excel'">
            <i class="pi pi-check" *ngIf="downloadAs === 'excel'"></i>
          </div>
          <span class="format-label" (click)="downloadAs = 'excel'">EXCEL</span>
        </div>
      </div>
    </div>
  </div>
  
  <!-- Content Area -->
  <div class="download-sidebar-content">
    <div class="download-columns-section">
      <div class="download-column-item select-all-item">
        <p-checkbox           
          [(ngModel)]="selectAllColumns"           
          (onChange)="toggleSelectAll()"          
          [binary]="true"
          inputId="selectAll">        
        </p-checkbox>        
        <label for="selectAll" class="download-column-label">Select All</label>      
      </div>
      
      <!-- Regular Column Items -->
      <div class="download-column-item" *ngFor="let col of colsToDownload">
        <p-checkbox           
          name="downloadColumns"           
          [value]="col"           
          [(ngModel)]="checkedColumns"           
          [inputId]="col.field"
          (onChange)="onColumnCheckChange()">        
        </p-checkbox>        
        <label [for]="col.field" class="download-column-label">{{col.header}}</label>      
      </div>
    </div>
  </div>
  
  <!-- Action Buttons -->
  <div class="download-actions">
    <div class="download-buttons-row">
      <button         
        pButton         
        class="cancel-btn"         
        [outlined]="true"
        label="Cancel"         
        (click)="showDownloadSidebar = false; resetCheckedColumnsToDefault()">      
      </button>      
      <button         
        pButton         
        class="download-btn"         
        label="Download"         
        [disabled]="checkedColumns.length === 0"        
        (click)="(downloadAs === 'excel') ? exportEvent('Excel') : exportEvent('csv')">      
      </button>    
    </div>    
    <button       
      pButton       
      [outlined]="true"
      class="download-all-btn"       
      [disabled]="loadingDownload"       
      (click)="exportAllEvents(downloadAs)"       
      [label]="'Download All Events'">    
    </button>  
  </div>
</p-drawer>
  
  <!-- Filter Tabs Container -->
  <div class="filter-tabs-container">
    <div class="filter-tabs">
      <div class="filter-tab" 
           [ngClass]="{'active': statusSelected === 'All'}" 
           (click)="getEventsByFilter('all'); setStatus('All')">
        All Events
        <span class="event-count" *ngIf="statusSelected === 'All'">{{ totalLength}}</span>
      </div>
      <div class="filter-tab" 
           [ngClass]="{'active': statusSelected === 'Saved'}" 
           (click)="getEventsByFilter('saved'); setStatus('Saved')">
        <em class="pi pi-bookmark tab-icon"></em>
        Saved
        <span class="event-count" *ngIf="statusSelected === 'Saved'">{{ totalLength}}</span>
      </div>
      <div class="filter-tab" 
           [ngClass]="{'active': statusSelected === 'Upcoming'}" 
           (click)="getEventsByFilter('upcoming'); setStatus('Upcoming')">
        <em class="pi pi-clock tab-icon"></em>
        Upcoming
        <span class="event-count" *ngIf="statusSelected === 'Upcoming'">{{ totalLength}}</span>
      </div>
      <div class="filter-tab" 
           [ngClass]="{'active': statusSelected === 'Ongoing'}" 
           (click)="getEventsByFilter('ongoing'); setStatus('Ongoing')">
        <em class="pi pi-play-circle tab-icon"></em>
        Ongoing
        <span class="event-count" *ngIf="statusSelected === 'Ongoing'">{{ totalLength}}</span>
      </div>
      <div class="filter-tab" 
          [ngClass]="{'active': statusSelected === 'Completed'}" 
          (click)="getEventsByFilter('completed'); setStatus('Completed')">
        <em class="pi pi-check-circle tab-icon"></em>
        Completed
        <span class="event-count" *ngIf="statusSelected === 'Completed'">{{ totalLength}}</span>
      </div>
    </div>

    <!-- Table Controls -->
    <div class="table-controls">
      <button pButton class="control-btn" (click)="showFilterSidebar = false; showSettingsSidebar = true; showDownloadSidebar = false" (click)="onClickSettingsSidebar()" pTooltip="Column Settings" tooltipPosition="top">
        <img src="assets/icons-svg/column-setting.svg" alt="Settings" />
      </button>
      <button pButton class="control-btn" *ngIf="userPrivileges.has('event.export')" (click)="showDownloadSidebar = true; showSettingsSidebar = false; showFilterSidebar = false" pTooltip="Download" tooltipPosition="top">
        <img src="assets/icons-svg/download.svg" alt="Download" />
      </button>
      <button pButton class="control-btn" (click)="refreshTable()" pTooltip="Refresh" tooltipPosition="top">
        <img src="assets/icons-svg/refresh.svg" alt="Refresh" />
      </button>
      <span class="table-menu">
        <p-select
        class="view-list-dropdown" 
        [options]="pageLimits" 
        [(ngModel)]="pageSize" 
        (onChange)="getEventsByLimit()">
      </p-select>
              <button pButton (click)="prev()" [disabled]="isFirstPage() || loadingSpinner" class="p-button-secondary p-button-text simple-btn">
          <img src="assets/icons-svg/chevron-left.svg" alt="Previous" class="icon-svg">
        </button>
        <button pButton class="disabled p-button-secondary p-button-text simple-btn">{{ loadingSpinner ? '...' : pageNumber + ' of ' + totalPages }}</button>
        <button pButton (click)="next()" [disabled]="isLastPage() || loadingSpinner" class="p-button-secondary p-button-text simple-btn">
          <img src="assets/icons-svg/chevron-right.svg" alt="Next" class="icon-svg">
        </button>
      </span>
    </div>
  </div>

  <!-- Main Table Container -->
  <div class="main-table-container">
    <p-table 
      #dt 
      [columns]="_selectedColumns" 
      [value]="loadingSpinner ? skeletonData : eventsList" 
      [resizableColumns]="true" 
      [rows]="pageSize" 
      [loading]="false" 
      [scrollable]="true" 
      scrollDirection="both" 
      responsiveLayout="scroll" 
      dataKey="id" 
      [selection]="selectedEvents" 
      (selectionChange)="onSelectedEventChange($event)" 
      [exportFilename]="exportName"
      styleClass="modern-table">
      

      <ng-template pTemplate="header" let-columns>
        <tr class="modern-table-header" [ngClass]="{'moveTable': showFilterSidebar || showSettingsSidebar || showDownloadSidebar}">
          <th scope="col" class="checkbox-column" pFrozenColumn>
            <div class="checkbox-container" *ngIf="!loadingSpinner && eventsList.length">
              <p-tableHeaderCheckbox [disabled]="loadingSpinner"></p-tableHeaderCheckbox>
            </div>
          </th>
          <th class="event-name-column" scope="col" pResizableColumn pFrozenColumn>EVENT NAME</th>
          <th [style]="{width: '11vw'}" scope="col" 
              pSortableColumn="{{ col.sortable ? col.field : null }}" 
              *ngFor="let col of columns" 
              pResizableColumn
              class="sortable-header">
            {{ col.header }}
            <p-sortIcon *ngIf="col.sortable" class="sort-icon" field="{{ col.field }}"></p-sortIcon>
          </th>
        </tr>
        <!-- Fixed selection operations row -->
        <tr class="selection-operations-row" *ngIf="selectedEvents.length && !loadingSpinner">
          <td [attr.colspan]="columns.length + 2" class="selection-operations-options">
            <div class="selection-operations-content">
              <span class="selection-count">{{selectedEvents.length}} Selected</span>
              <div class="selection-buttons">
                <button *ngIf="userPrivileges.has('event.delete')" 
                        pButton 
                        pRipple 
                        class="icon-action-btn delete-btn" 
                        (click)="deleteEvent(selectedEvents[0])" 
                        [disabled]="selectedEvents.length > 1 || selectedEvents[0].candidateCount > 0"
                        pTooltip="Delete Event" 
                        tooltipPosition="top">
                  <img src="assets/icons-svg/delete.svg" alt="Delete" class="action-icon" />
                </button>
                <button *ngIf="userPrivileges.has('event.create') && userPrivileges.has('event.view')" 
                        pButton 
                        pRipple 
                        class="icon-action-btn clone-btn" 
                        (click)="cloneEvent(selectedEvents[0])" 
                        [disabled]="selectedEvents.length > 1"
                        pTooltip="Clone Event" 
                        tooltipPosition="top">
                  <img src="assets/icons-svg/size.svg" alt="Clone" class="action-icon" />
                </button>
              </div>
            </div>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-event let-columns="columns">
        <tr class="modern-table-row" [ngClass]="{'moveTable': showFilterSidebar || showSettingsSidebar || showDownloadSidebar, 'skeleton-row': loadingSpinner}" [style]="{cursor: loadingSpinner ? 'default' : 'pointer'}">
          <td class="checkbox-column" pFrozenColumn>
            <div class="checkbox-container">
              <ng-container *ngIf="!loadingSpinner; else skeletonCheckbox">
                <p-tableCheckbox [value]="event"></p-tableCheckbox>
              </ng-container>
              <ng-template #skeletonCheckbox>
                <div class="skeleton skeleton-checkbox"></div>
              </ng-template>
            </div>
          </td>
          <td 
            (click)="!loadingSpinner && userPrivileges.has('event_candidate.view') ? openCandidates(event.id, event.eventCategory ?? event.category) : null" 
            class="event-name-column" 
            pFrozenColumn>
            <ng-container *ngIf="!loadingSpinner; else skeletonText">
              <span class="event-name">{{ event.name }}</span>
            </ng-container>
            <ng-template #skeletonText>
              <div class="skeleton skeleton-text skeleton-text-long"></div>
            </ng-template>
          </td>
          <td *ngFor="let col of columns" 
              (click)="!loadingSpinner && userPrivileges.has('event_candidate.view') ? openCandidates(event.id, event.eventCategory ?? event.category) : null" 
              [style]="{width: '11vw'}">
            <ng-container *ngIf="!loadingSpinner; else skeletonCell">
              <span [ngSwitch]="true" class="box-data">
                <span *ngSwitchCase="col.field === 'event_status'" class="modern-status-badge" [ngClass]="getStatusClass(event[col.field])">
                  {{ event[col.field] ? (event[col.field] | titlecase) : '-' }}
                </span>
                <span *ngSwitchCase="col.field === 'job_roles'" class="jobRole-op">
                  <span *ngIf="event[col.field]?.length && event[col.field][0] != null; else elseContent">
                    <span class="role-name-text">{{ event[col.field][0].name}}</span>
                    <div *ngIf="event[col.field].length > 1" class="remainingItems-badge">
                      <p-badge 
                        value="+{{event[col.field].length - 1}}" 
                        styleClass="mr-2" 
                        [pTooltip]="getJobRolesTooltip(event[col.field])" 
                        tooltipPosition="top"
                        [escape]="false">
                      </p-badge>
                    </div>
                  </span>
                  <ng-template #elseContent>-</ng-template>
                </span>
                <span *ngSwitchCase="col.field == 'event_start_date' || col.field == 'event_end_date' || col.field == 'registration_start_date' || col.field == 'registration_end_date' || col.field == 'created_at'">
                  {{ event[col.field] | date: combineFormat || '-'}}
                </span>
                <span *ngSwitchCase="col.field === 'institutes'" class="instituteName-op">
                  <span *ngIf="event[col.field]?.length > 0; else emptyInstitute">
                    <span class="institute-name-text">{{ event[col.field][0]?.name || '-' }}</span>
                    <div *ngIf="event[col.field].length > 1" class="remainingItems-badge">
                      <p-badge 
                        value="+{{event[col.field].length - 1}}" 
                        styleClass="mr-2" 
                        [pTooltip]="getInstitutesTooltip(event[col.field])" 
                        tooltipPosition="top"
                        [escape]="false">
                      </p-badge>
                    </div>
                  </span>
                  <ng-template #emptyInstitute>-</ng-template>
                </span>
                <span *ngSwitchCase="col.field === 'created_by'">
                  {{ (event.created_by?.first_name && event.created_by?.last_name) ? (event.created_by.first_name + ' ' + event.created_by.last_name) : '-' }}
                </span>
                <span *ngSwitchCase="col.field == 'activeCount' || col.field == 'hiredCount' || col.field == 'appliedCount' || col.field == 'candidateCount'">
                  {{ event[col.field] ? event[col.field] : '0' }}
                </span>
                <span *ngSwitchDefault>
                  {{ event[col.field] ? event[col.field] : '-' }}
                </span>
              </span>
            </ng-container>
            <ng-template #skeletonCell>
              <div class="skeleton" [ngClass]="{
                'skeleton-badge': col.field === 'event_status',
                'skeleton-text': col.field !== 'event_status',
                'skeleton-text-short': col.field === 'activeCount' || col.field === 'hiredCount' || col.field === 'appliedCount' || col.field === 'candidateCount'
              }"></div>
            </ng-template>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td [attr.colspan]="_selectedColumns.length + 2" class="empty-message-container">
            <div class="empty-state">
              <div class="empty-state-icon">
                <i class="pi pi-search"></i>
              </div>
              <h3 class="empty-state-title">No Events Found</h3>
              <p class="empty-state-description">
                Try adjusting filters or search terms.
              </p>
            </div>
          </td>
        </tr>
      </ng-template>    
    </p-table>
  </div>
</div>